import { Immutable } from "immer";
import React from "react";
import { DataLayerPush } from "tsi-common-react/src/components/DataLayerPush/index";
import { GASeller } from "tsi-common-react/src/components/GASeller/index";

import { templates } from "@reactivated";

import { OrderDetail } from "../components/OrderDetail";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: Immutable<templates.ThankYouDocumentTemplate>,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            {/* order is the cocoon shape; the shared template types it as
                nullable (the pillows shape lives in a sibling prop), but on
                cocoon it is always populated. */}
            {props.order && <OrderDetail order={props.order} />}
            <DataLayerPush events={props.ga_events} />
            <GASeller surveyData={props.ga_seller_survey_data} />
        </PageSkeleton>
    );
};
